import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CustomPermissionAuthService {

  private customPermissionKeys = new Set<string>();
  private permissionsChanged = new Subject<void>();
  
  // Observable para notificar cambios en los permisos
  public permissionsChanged$ = this.permissionsChanged.asObservable();

  constructor() { 
    this.loadPermissionsFromAuth();
    
  }

  private loadPermissionsFromAuth(): void {
    const userData = AuthService.getUser();
    if (userData && userData.customPermissions) {
      this.customPermissionKeys = new Set(userData.customPermissions);
    } else {
      this.customPermissionKeys.clear();
    }
    this.notifyPermissionsChanged();
  }

  public hasPermission(permissionKey: string): boolean {
    return this.customPermissionKeys.has(permissionKey);
  }

  public hasAnyPermission(permissionKeys: string[]): boolean {
    return permissionKeys.some(permission => this.customPermissionKeys.has(permission));
  }

  public hasAllPermissions(permissionKeys: string[]): boolean {
    return permissionKeys.every(permission => this.customPermissionKeys.has(permission));
  }

  public getPermissions(): string[] {
    return Array.from(this.customPermissionKeys);
  }

  public updatePermissions(permissions: string[]): void {
    this.customPermissionKeys = new Set(permissions);
    this.notifyPermissionsChanged();
  }

  public clearPermissions(): void {
    this.customPermissionKeys.clear();
    this.notifyPermissionsChanged();
  }

  private notifyPermissionsChanged(): void {
    this.permissionsChanged.next();
  }
}
